import { deviceChange, isMobileQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { USER_PROFILE_DATA } from '@gig/magic-messages';
import { ListenMessageType } from '@gig/magic-galleon';
import CashierMixin from '../../mixins/cashier.mixin.js';

var QuickPayment = /** @class */ (function (_super) {
    __extends(QuickPayment, _super);
    function QuickPayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMobile = null;
        _this.vertical = false;
        _this.isPlacedTop = null;
        return _this;
    }
    QuickPayment.prototype.hasCustomContent = function (slot) {
        return this.$slots[slot];
    };
    QuickPayment.prototype.onLoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // First determine if we're on mobile
                        _a = this;
                        return [4 /*yield*/, isMobileQuery()];
                    case 1:
                        // First determine if we're on mobile
                        _a.isMobile = _b.sent();
                        // Set up device change subscription
                        this.deviceSubscription = deviceChange(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = this;
                                        return [4 /*yield*/, isMobileQuery()];
                                    case 1:
                                        _a.isMobile = _b.sent();
                                        // Only dispatch event if component is mounted and refs are available
                                        if (this.$refs.quickpayment) {
                                            this.dispatchEvent(ListenMessageType.Device, {
                                                isMobile: this.isMobile,
                                            });
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        // Initialize wallet and apply styles only if component is mounted
                        if (this.$refs.quickpayment) {
                            this.initiateWallet();
                            this.applyStyles();
                        }
                        else {
                            console.warn('Component not fully mounted, deferring wallet initialization and styles');
                            // Use nextTick to wait until the DOM is updated
                            this.$nextTick(function () {
                                if (_this.$refs.quickpayment) {
                                    _this.initiateWallet();
                                    _this.applyStyles();
                                }
                                else {
                                    console.error('Component refs still not available after nextTick');
                                }
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    QuickPayment.prototype.initiateWalletProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var profile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProfileEventData()];
                    case 1:
                        profile = _a.sent();
                        // Only dispatch event if component is mounted and refs are available
                        if (this.$refs.quickpayment) {
                            this.dispatchEvent(ListenMessageType.UpdateProfile, {
                                profile: profile,
                            });
                        }
                        else {
                            console.warn('Cannot update profile: quickpayment reference is undefined');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    QuickPayment.prototype.getUserProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userProfile) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 1:
                        _a.userProfile = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.userProfile];
                }
            });
        });
    };
    QuickPayment.prototype.getProfileEventData = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function () {
            var userProfile, user, resultPhone, profile;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0: return [4 /*yield*/, this.getUserProfile()];
                    case 1:
                        userProfile = _l.sent();
                        user = userProfile.user;
                        resultPhone = (((_a = user.mobileNumber) === null || _a === void 0 ? void 0 : _a.prefix) || '') +
                            (((_b = user.mobileNumber) === null || _b === void 0 ? void 0 : _b.number) || '');
                        if (!((_c = user.mobileNumber) === null || _c === void 0 ? void 0 : _c.number)) {
                            resultPhone =
                                (((_d = user.telephoneNumber) === null || _d === void 0 ? void 0 : _d.prefix) || '') +
                                    (((_e = user.telephoneNumber) === null || _e === void 0 ? void 0 : _e.number) || '');
                        }
                        profile = {
                            customer: {
                                firstName: user.givenName,
                                lastName: user.familyName,
                                email: user.email,
                                phone: resultPhone,
                                dateOfBirth: {
                                    // Parse birthdate and extract components, assuming format is YYYY-MM-DD
                                    day: new Date(user.birthDate).getDate(),
                                    month: new Date(user.birthDate).getMonth() + 1,
                                    year: new Date(user.birthDate).getFullYear(),
                                },
                            },
                            billingAddress: {
                                street: (_f = user.address) === null || _f === void 0 ? void 0 : _f.streetAddress,
                                city: (_g = user.address) === null || _g === void 0 ? void 0 : _g.addressLocality,
                                zip: (_h = user.address) === null || _h === void 0 ? void 0 : _h.postalCode,
                                country: (_j = user.address) === null || _j === void 0 ? void 0 : _j.addressCountry,
                                state: (_k = user.address) === null || _k === void 0 ? void 0 : _k.addressRegion,
                            },
                        };
                        return [2 /*return*/, profile];
                }
            });
        });
    };
    QuickPayment.prototype.dispatchEvent = function (name, detail) {
        var quickPaymentRef = this.$refs.quickpayment;
        if (!quickPaymentRef) {
            console.warn('quickpayment reference is undefined, cannot dispatch event:', name);
            return;
        }
        var viewEvent = new CustomEvent(name, { detail: detail });
        quickPaymentRef.dispatchEvent(viewEvent);
    };
    QuickPayment.prototype.applyStyles = function () {
        var quickPaymentRef = this.$refs.quickpayment;
        if (!quickPaymentRef) {
            console.warn('quickpayment reference is undefined, cannot apply styles');
            return;
        }
        var styleSheet = new CSSStyleSheet();
        // @ts-ignore
        styleSheet.replaceSync(window.cashierStyles);
        // @ts-ignore
        quickPaymentRef.shadowRoot.adoptedStyleSheets.push(styleSheet);
    };
    QuickPayment.prototype.destroyed = function () {
        var _a, _b;
        (_a = this.verticalSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.deviceSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    };
    QuickPayment.prototype.initiateWallet = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initiateWalletConfig()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.initiateWalletTranslations()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.initiateWalletProfile()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuickPayment.prototype.closeQuickPayment = function () {
        // purpose: event propagate to game-navigation
    };
    __decorate([
        Emit('close-payment'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], QuickPayment.prototype, "closeQuickPayment", null);
    QuickPayment = __decorate([
        Component({
            name: 'quick-payment-content',
        })
    ], QuickPayment);
    return QuickPayment;
}(Mixins(MagicConfigMixin, CashierMixin)));

export default QuickPayment;
